import { replace } from 'lodash'

export function parseMultiColumnName(name) {
  if (!name) return
  return name.replace(/^MULTI_/, '')
}

export function multiColumnName(name) {
  return `MULTI_${name}`
}

export function shiftNumbersInString(string, offset = 1) {
  return replace(string, /\d+/g, (number) => String(Number(number) + Number(offset))) // @regex matches any numbers
}